import { useAtom } from 'jotai';
import { useLayoutEffect } from 'react';
import { siteThemeMode, ThemeMode } from '~/atoms/userPreferencesAtoms';
import darkThemeCss from '~/styles/themes/dark/style.css?inline';
import lightThemeCss from '~/styles/themes/light/style.css?inline';
import { createAgTheme } from '~/components/ui/tables/ag/agTheme';

const THEME_STYLE_IDS: Record<ThemeMode, string> = {
  dark: 'kepler-theme-dark',
  light: 'kepler-theme-light',
};

const THEME_CSS: Record<ThemeMode, string> = {
  dark: darkThemeCss,
  light: lightThemeCss,
};

const applyThemeClasses = (mode: ThemeMode) => {
  if (typeof document === 'undefined') return;

  document.documentElement.dataset.theme = mode;
  document.body.classList.remove('theme-dark', 'theme-light');
  document.body.classList.add(mode === 'dark' ? 'theme-dark' : 'theme-light');
};

const ensureThemeStyles = (mode: ThemeMode) => {
  if (typeof document === 'undefined') return;

  const styleId = THEME_STYLE_IDS[mode];
  let styleTag = document.getElementById(styleId) as HTMLStyleElement | null;

  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = styleId;
    styleTag.textContent = THEME_CSS[mode];
    document.head.appendChild(styleTag);
  }

  const oppositeMode: ThemeMode = mode === 'dark' ? 'light' : 'dark';
  const staleStyle = document.getElementById(THEME_STYLE_IDS[oppositeMode]);
  staleStyle?.remove();
};

export const ThemeManager = () => {
  const [mode] = useAtom(siteThemeMode);

  useLayoutEffect(() => {
    ensureThemeStyles(mode);
    applyThemeClasses(mode);
    if (typeof window !== 'undefined') {
      (window as any).__agTheme = createAgTheme(mode);
    }
  }, [mode]);

  return null;
};
